import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import {
  MERCHANT_WING3,
} from '../constants/merchant'
import _ from 'lodash'
import URLParser from 'helpers/urlParser'

const ProtectedRoute = ({ component: Component, isTakeaway, takeawayStatus, takeawayOrders, ...rest }) => {
  const urlParser = new URLParser(window.location.href)
  const params = urlParser.getParams()
  const {
    m: merchantId,
  } = params

  const existingBasket = _.get(rest, 'basket', {})

  let redirectToTakeawayWaiting = !(
    takeawayStatus === 'complete' ||
    takeawayStatus === 'cancel' ||
    takeawayStatus === 'delivered' ||
    takeawayStatus == null ||
    takeawayStatus === undefined ||
    isTakeaway !== true
  )

  if (
    merchantId &&
    existingBasket !== merchantId
  ) {
    redirectToTakeawayWaiting = false
  }

  // debugger
  // CCB
  // if (
  //   _.get(rest, 'basket.isStoreDelivery') &&
  //   [
  //     MERCHANT_CAMPAIGN_CCB_1,
  //     MERCHANT_CAMPAIGN_CCB_2,
  //     MERCHANT_CAMPAIGN_CCB_3,
  //     MERCHANT_WING3,
  //   ].includes(_.get(rest, 'basket.merchantId')) &&
  //   !window._justSubmittedOrder
  // ) {
  //   // not to redirect to waiting, if ccb
  //   redirectToTakeawayWaiting = false
  // }

  return (
    <Route
      {...rest} render={(props) => (
        redirectToTakeawayWaiting
          ? <Redirect to={{ pathname: '/basket/takeaway_waiting', state: { from: props.location } }} />
          : <Component {...props} />
      )}
    />
  )
}

export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.js